import {required} from "vuelidate/lib/validators";  
const satonaybelgesi = {
    data() { 
      return {   
        satonaybelgesiData: { 
          Belgetarih: "",
          Belgesayi: "",
          Isintanimi: "",
          Isinmiktari: "",
          Teminat: "",
          Yatirimprojenu: "",
          Butcetertibi: "",
          Saymanlik: "",
          Avans: "",
          Ilansekliadeti: "",
          Dokumanbedel: 0,
          Sozlesmevarmi: "",
          Fiyatfarkivarmi: "",
          Aciklama: "",
          Gorevliler:[],
        Gerceklestimeid:null,
         Harcamaid:null,
          Kullanilabilirodenek:0,
          Deleted: false,

          }, 


          FormDataType:{
            Belgetarih:{FieldName:"Belgetarih",Field:"input",FieldTitle: this.$t('satonaybelgesi.Page.Belgetarih'),FieldType:"date"},
            Belgesayi:{FieldName:"Belgesayi",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Belgesayi')},  
            Isintanimi:{FieldName:"Isintanimi",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Isintanimi')},  
            Isinmiktari:{FieldName:"Isinmiktari",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Isinmiktari')},  
            Teminat:{FieldName:"Teminat",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Teminat')}, 
            Yatirimprojenu:{FieldName:"Yatirimprojenu",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Yatirimprojenu')}, 
            Butcetertibi:{FieldName:"Butcetertibi",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Butcetertibi'),ComboDataArray:[]}, 
            Saymanlik:{FieldName:"Saymanlik",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Saymanlik')}, 
            Avans:{FieldName:"Avans",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Avans')}, 
            Ilansekliadeti:{FieldName:"Ilansekliadeti",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Ilansekliadeti')}, 
            Dokumanbedel:{FieldName:"Dokumanbedel",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Dokumanbedel'),FieldType:"number"},
            Sozlesmevarmi:{FieldName:"Sozlesmevarmi",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Sozlesmevarmi')},
            Fiyatfarkivarmi:{FieldName:"Fiyatfarkivarmi",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Fiyatfarkivarmi')}, 
            Aciklama:{FieldName:"Aciklama",Field:"textarea",FieldTitle:this.$t('satonaybelgesi.Page.Aciklama')},  
            Gorevliler:{FieldName:"Gorevliler",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Gorevliler'),ComboDataArray:[]}, 
            Gerceklestimeid:{FieldName:"Gerceklestimeid",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Gerceklestimeid'),ComboDataArray:[]}, 
            Harcamaid:{FieldName:"Harcamaid",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Harcamaid'),ComboDataArray:[]},
            Kullanilabilirodenek:{FieldName:"Kullanilabilirodenek",Field:"input",FieldTitle:this.$t('satonaybelgesi.Page.Kullanilabilirodenek'),FieldType:"number"},
                   
          } 
      }
    },  
    validations:{ 
      FormData: {  
        Belgetarih:{required},  
        Belgesayi:{required}, 
        Isintanimi:{},
        Isinmiktari: {required},
        Teminat: {},
        Yatirimprojenu: {},
        Butcetertibi: {},
        Saymanlik: {},
        Avans: {},
        Ilansekliadeti: {required},
        Dokumanbedel: {required},
        Sozlesmevarmi: {},
        Fiyatfarkivarmi: {},
        Aciklama: {required},
        Gorevliler:{required},
        Gerceklestimeid:{},
        Harcamaid:{},
        Kullanilabilirodenek:{required},
      }
 
  },
  created(){

          let Page= {
            PageNumber: "1",
            PageSize: "9999"
          }

       /*     this.ActionsGet({"Service":"OPersonel", "Page":Page}).then((res) => {
                for(var i=0; i<res.Data.length; i++)
                {
                  this.FormDataType.Gorevliler.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Adsoyad})
                  this.FormDataType.Gerceklestimeid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Adsoyad})
                  this.FormDataType.Harcamaid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Adsoyad})
                } 

            });*/

            this.ActionsGet({"Service":"StrHesapKodlari", "Page":Page}).then((res) => {
              for(var i=0; i<res.Data.length; i++)
              {
                if (res.Data[i].Kod.length>9){
                  this.FormDataType.Butcetertibi.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Kod+" - "+res.Data[i].Aciklama})
                }
              } 

          });
 



         

  }
}
export default satonaybelgesi